var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"27821ae3517386d6658df019710a616c7fcda5af"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["supabase-app-staging@supabase"]={id:"27821ae3517386d6658df019710a616c7fcda5af"};
      